import { BaseComponent } from '../../base-component'
import { Nullable } from '../../../types/common'
import { $el, $list, $elParent } from 'src/scripts/utils/utils'
import { ProductCard } from './product-card'

const PRODUCT_CARD_SELECTOR = 'product-card'
const ITEM_SELECTOR = '[data-product-media-tabs-item]'

export class ProductMediaTabs extends BaseComponent {
  selected: Nullable<{ img: any; tab: any }> = null

  mountComponent(): void {
    const tabs = $list(ITEM_SELECTOR, this)

    tabs.forEach(tab => {
      this.addListener(tab, 'mouseenter', this.handleTabEnter)
      this.addListener(tab, 'mouseleave', this.handleTabLeave)
    })
  }

  handleTabEnter = (event): void => {
    const productCard: ProductCard = $elParent(PRODUCT_CARD_SELECTOR, this)
    const tab = event.currentTarget
    const img = $el(`[data-id="${tab.dataset.id}"]`, productCard)

    if (this.selected) {
      this.reset()
    }

    this.setTabSelect(tab, true)
    this.setImageVisible(productCard.getMainMedia(), false)
    this.setImageVisible(img, true)

    this.selected = { tab, img }
  }

  handleTabLeave = (): void => {
    const productCard: ProductCard = $elParent(PRODUCT_CARD_SELECTOR, this)

    if (this.selected) {
      this.reset()
    }

    this.setImageVisible(productCard.getMainMedia(), true)
  }

  setTabSelect(tab: HTMLElement, isSelected: boolean): void {
    tab.classList.toggle('selected', isSelected)
  }

  setImageVisible(img: HTMLElement, isVisible: boolean): void {
    img.classList.toggle('product-card__img--visible', isVisible)
  }

  reset(): void {
    if (!this.selected) {
      return
    }

    this.selected.img.classList.remove('product-card__img--visible')
    this.selected.tab.classList.remove('selected')
    this.selected = null
  }
}
